/* eslint-disable no-console */
/* eslint-disable max-len */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useContext, useState } from 'react';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { LanguageContext } from '../../../../libs/Context';
import useMoveToTrash from '../../customHooks/useMoveToTrash';
import { MediaContext } from '../..';
import { useParams } from 'react-router-dom';

const MoveToTrashPopUp = (props) =>
{
	const { folderData, handleClosePreview, type, handlePopup } = props;
	const [ loading, setLoading ] = useState<boolean>(false);
	const { language } = useContext(LanguageContext);
	const { mediaState } = useContext(MediaContext);
	const getMoveToTrash = useMoveToTrash();

	const folderIds = mediaState?.selectedData?.length > 0 && mediaState?.selectedData?.map((item:any) => item?.folderId);
	const tabValue = useParams()?.tab;

	const handleMoveTrash = () =>
	{
		if (!loading)
		{
			setLoading(true);

			const idArr = folderIds?.length > 0 ? folderIds : [ folderData?.folderId ];
			const userId = tabValue === 'employee' ? folderData?.userId : '';

			getMoveToTrash({ idArray: idArr, setLoading, userId });
			handlePopup({ trash: false });
			type === 0 && handleClosePreview();
		}
	};

	return (
		<Dialog
			open
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle>
				{language.moveToTrash}
			</DialogTitle>
			<DialogContent>
				{loading && <Loading />}
				{language.areYouSureFileToTrash}
			</DialogContent>
			<DialogActions>
				<Button
					color='primary'
					disableElevation
					disableFocusRipple
					disableRipple
					disableTouchRipple
					onClick={() => handlePopup({ trash: false })}
				>
					{language.cancel}
				</Button>
				<Button
					variant='contained'
					color='primary'
					className='whiteTxt'
					disableElevation
					disableFocusRipple
					disableRipple
					disableTouchRipple
					onClick={handleMoveTrash}
				>
					{language.trash}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default MoveToTrashPopUp;